import { getAuth, GoogleAuthProvider, signInWithPopup, RecaptchaVerifier, signInWithPhoneNumber, signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";

// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";
import { signInUpdate } from "./dataHandler";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries



    // Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  };
  
  // Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export const getAuthState = () => getAuth(app)
export const getFirebaseDatabase=()=>database
export const getFirebaseFunctions=()=>getFunctions(app)

export const firebaseGoogleSignIn = async () =>{
   const result = await  signInWithPopup(getAuth(app), new GoogleAuthProvider())
    // This gives you a Google Access Token. You can use it to access the Google API.
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    // The signed-in user info.
    const user = result.user;
    signInUpdate(user.uid, {
        uid : user.uid,
        name: user.displayName,
        email: user.email,
        isEmailVerified : user.emailVerified,
        isAnonymous: user.isAnonymous,
        photo : user.photoURL,
        phone : user.phoneNumber,
        lastSignIn: new Date().toString(),
        profileId: `DFC_${user.uid}`
    })
   return user
}

export const firebaseGoogleSignOut = async () => await getAuth().signOut()

export const firebaseEmailSignIn = async (email, password) => {
    const result = await signInWithEmailAndPassword(getAuth(app), email, password);
    const user = result.user;
    signInUpdate(user.uid, {
        uid : user.uid,
        name: user.displayName || user.email.split('@')[0],
        email: user.email,
        isEmailVerified : user.emailVerified,
        isAnonymous: user.isAnonymous,
        photo : user.photoURL,
        phone : user.phoneNumber,
        lastSignIn: new Date().toString(),
        profileId: `DFC_${user.uid}`
    });
    return user;
};

export const firebaseEmailSignUp = async (email, password) => {
    const result = await createUserWithEmailAndPassword(getAuth(app), email, password);
    const user = result.user;
    signInUpdate(user.uid, {
        uid : user.uid,
        name: user.displayName || user.email.split('@')[0],
        email: user.email,
        isEmailVerified : user.emailVerified,
        isAnonymous: user.isAnonymous,
        photo : user.photoURL,
        phone : user.phoneNumber,
        lastSignIn: new Date().toString(),
        profileId: `DFC_${user.uid}`
    });
    return user;
};

export const updateUserAuthProfile = async (displayName, photoURL) => {
    const auth = getAuth(app);
    if (auth.currentUser) {
        await updateProfile(auth.currentUser, {
            displayName: displayName || auth.currentUser.displayName,
            photoURL: photoURL || auth.currentUser.photoURL
        });
        return auth.currentUser;
    }
    throw new Error("No user logged in");
};

export const setupRecaptcha = (containerId) => {
    const auth = getAuth(app);
    
    if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(containerId, {
            'size': 'invisible',
        }, auth);
    }
    return window.recaptchaVerifier;
};

export const sendOtp = async (phoneNumber, appVerifier) => {
    const auth = getAuth(app);
    const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
    window.confirmationResult = confirmationResult;
    return confirmationResult;
};

export const verifyOtp = async (otp) => {
    if (!window.confirmationResult) throw new Error("No confirmation result available");
    const result = await window.confirmationResult.confirm(otp);
    return result.user;
};
